const orderManage = () => import('@/view/order/order-manage');
const orderDetail = () => import('@/view/order/order-detail');
const service = () => import('@/view/order/service');
const service2 = () => import('@/view/order/service2');
const service3 = () => import('@/view/order/service3');
const serviceDetail = () => import('@/view/order/service-detail');
const serviceDetail2 = () => import('@/view/order/service-detail2');

export default [{
    path: '/order-manage',
    name: 'orderManage',
    component: orderManage
  },
  {
    path: '/order-detail',
    name: 'orderDetail',
    component: orderDetail
  }, {
    path: '/service',
    name: 'service',
    component: service
  },
  {
    path: '/service2',
    name: 'service2',
    component: service2
  },
  {
    path: '/service3',
    name: 'service3',
    component: service3
  },
  {
    path: '/service-detail',
    name: 'serviceDetail',
    component: serviceDetail
  },
  {
    path: '/service-detail2',
    name: 'serviceDetail2',
    component: serviceDetail2
  }
];